"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadOpacityUpdater = void 0;
const OpacityUpdater_1 = require("./OpacityUpdater");
function loadOpacityUpdater(tsParticles) {
    tsParticles.addParticleUpdater("opacity", () => new OpacityUpdater_1.OpacityUpdater());
}
exports.loadOpacityUpdater = loadOpacityUpdater;
